import script from "./GroupPhotoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPhotoSection.vue?vue&type=script&setup=true&lang=js"

import "./GroupPhotoSection.vue?vue&type=style&index=0&id=9cfeaf0c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cfeaf0c"]])

export default __exports__